import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';
import axios from 'axios';
import {
    ICommissionDownload,
    ICommissionSummaryRequest,
    ICommissionSummaryResponse,
} from './types';
import { ERROR_MESSAGES } from './config';

export const getCommissionSummary = async (
    partnerId: string,
    request: ICommissionSummaryRequest
): Promise<ICommissionSummaryResponse> => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/v1/reports/partner/${partnerId}/order/commission-summary`,
            ...getAxiosConfig(),
            data: request,
        });

        const { data, status } = response;
        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }

        return {
            status: false,
            ...data,
        } as ICommissionSummaryResponse;
    } catch (e: any) {
        console.log('Error while getting commission summary', e);
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }

        let errorMessage = '';
        if (e?.response?.status === 500)
            errorMessage = ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED;
        else errorMessage = e?.response?.data?.message;

        return {
            status: false,
            message: errorMessage,
        } as ICommissionSummaryResponse;
    }
};

export const getReportHistory = async (
    request: ICommissionSummaryRequest
): Promise<ICommissionSummaryResponse> => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/v1/reports/history`,
            ...getAxiosConfig(),
            data: request,
        });

        const { data, status } = response;

        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }

        return {
            status: false,
            ...data,
        } as ICommissionSummaryResponse;
    } catch (e: any) {
        console.log('Error while getting report history', e);
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        let errorMessage = '';
        if (e?.response?.status === 500)
            errorMessage =
                ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED;
        else errorMessage = e?.response?.data?.message;

        return {
            status: false,
            message: errorMessage,
        } as ICommissionSummaryResponse;
    }
};

export const downloadReportById = async (requestId: string): Promise<any> => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/v1/reports/${requestId}/download`,
            ...getAxiosConfig(),
        });

        const { data, status } = response;
        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }

        return {
            status: false,
            ...data,
        };
    } catch (e: any) {
        console.log('Error while downloading report', e);
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        console.error('Error downloading report:', e);

        let errorMessage = '';
        if (e?.response?.status === 500)
            errorMessage = ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED;
        else errorMessage = e?.response?.data?.message;

        return {
            status: false,
            message: errorMessage,
        };
    }
};

export const refetchReportStatus = async (requestId: string): Promise<any> => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/v1/reports/${requestId}/status`,
            ...getAxiosConfig(),
        });

        const { data, status } = response;

        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }

        return {
            status: false,
            ...data,
        };
    } catch (e: any) {
        console.log('Error while refetching report status', e);
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }

        let errorMessage = '';
        if (e?.response?.status === 500)
            errorMessage = ERROR_MESSAGES.GET_LATEST_STATUS_FAILED;
        else errorMessage = e?.response?.data?.message;

        return {
            status: false,
            message: errorMessage,
        };
    }
};

export const generateReport = async (
    request: ICommissionSummaryRequest
): Promise<ICommissionDownload> => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/v1/reports/generate`,
            ...getAxiosConfig(),
            data: request,
        });

        const { data, status } = response;
        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }
        return {
            status: false,
            ...data,
        } as ICommissionDownload;
    } catch (e: any) {
        console.log('Error while generating report', e);
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        let errorMessage = '';
        if (e?.response?.status === 500)
            errorMessage = ERROR_MESSAGES.REPORT_GENERATE_FAILED;
        else errorMessage = e?.response?.data?.message;

        return {
            status: false,
            message: errorMessage,
        } as ICommissionDownload;
    }
};
